'use strict';

var angularModule = angular.module('t2g.common.services.userSessionService', []);

module.exports = angularModule;

var STORAGE_KEY = 'UserSession';

angularModule.factory('UserSession', function(localStorageService, $timeout) {
  var _isLoggedIn = false;
  var _user;

  var saveUserToSession = function() {
    localStorageService.set(STORAGE_KEY, _user);
  };

  return {
    isLoggedIn: function() {
      return _isLoggedIn;
    },
    setLoggedIn: function() {
      _isLoggedIn = true;
    },
    hasRole: function(roleName) {
      return _user.roles.indexOf(roleName) > -1;
    },
    clean: function() {
      localStorageService.remove(STORAGE_KEY);
    },
    getOffice: function() {
      return _user ? _user.office : undefined;
    },
    get: function() {
      // get from session if empty store on session
      _user = _user || localStorageService.get(STORAGE_KEY);
      return _user;
    },
    set: function(user, callback) {
      _user = user || _user;
      saveUserToSession();

      if (callback) {
        $timeout(function() {
          callback();
        }, 400);
      }
    },
    qSet: function(user) {
      _user = user || _user;
      saveUserToSession();
      return $timeout(angular.noop, 250);
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/services/UserSession.js